export default __webpack_public_path__ + "static/media/defaultPurpleLogo.b5c33001.png";